import { Cookies } from '@/domain/cookie/Cookies';
import TrackingCookieService from '@/services/TrackingCookieService';

export default class MatomoCookieService extends TrackingCookieService {
  protected cookieName = Cookies.isMatomoTrackingAllowed;
  private static instance: MatomoCookieService = new MatomoCookieService();

  private constructor() {
    super();
  }

  public static singleton(): MatomoCookieService {
    return this.instance;
  }
}
